"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var IncompleteCartProps_1 = require("./IncompleteCartProps");
var IncompleteCartState_1 = require("./IncompleteCartState");
var localStyles = require("./IncompleteCart.scss");
var ui_components_1 = require("@idp/ui-components");
var LabelProps_1 = require("@idp/ui-components/components/atoms/Label/LabelProps");
var utils_1 = require("@idp/ui-components/utils");
var cms_integration_1 = require("@idp/cms-integration");
var Cart_cms_1 = require("../../../cms/Cart.cms");
var routables_1 = require("@idp/routables");
var ReportingService_1 = require("../../../api/ReportingService");
var Utils = require("../../../utils/UtilityFunctions");
var cartUtils = require("../../../utils/CartUtilFunctions");
var CartHelperFunctions_1 = require("../../../utils/CartHelperFunctions");
var cartConfigCss = require("../../CartConfigurationContainer/CartConfiguration.scss");
var CartViewPanelProps_1 = require("../../panels/CartViewPanel/CartViewPanelProps");
var components_1 = require("@idp/duc/components");
var IncompleteCart = /** @class */ (function (_super) {
    __extends(IncompleteCart, _super);
    function IncompleteCart(props) {
        var _this = _super.call(this, props) || this;
        _this.toCheckout = {
            DEFAULT_INCOMPLETE_MESSAGE: false,
            DTVS_ADDON: false,
            IPTV_ADDON: false,
            WLS_DEVICE: false,
            WLS_DEVICE_CELLPHONE: false,
            WLS_PLAN: false,
        };
        _this.isCartIncomplete = false;
        _this.state = new IncompleteCartState_1.default();
        _this.reportingService = new ReportingService_1.default();
        _this.errorMsg = _this.errorMsg.bind(_this);
        return _this;
    }
    IncompleteCart.prototype.render = function () {
        this.cmsContent = cms_integration_1.CMS.get(new Cart_cms_1.CartCms(), 'cartcheckout').content.common.incompleteCart;
        this.updateIncompleteCart();
        if (this.isCartIncomplete) {
            return (React.createElement("div", { className: [cartConfigCss.mb10, cartConfigCss.pt14].join(' ') }, this.errorMsg()));
        }
        else {
            return React.createElement(React.Fragment, null);
        }
    };
    IncompleteCart.prototype.updateIncompleteCart = function () {
        var _a;
        this.isCartIncomplete = false;
        this.toCheckout = {
            DEFAULT_INCOMPLETE_MESSAGE: false,
            DTVS_ADDON: false,
            IPTV_ADDON: false,
            WLS_DEVICE: false,
            WLS_DEVICE_CELLPHONE: false,
            WLS_PLAN: false,
        };
        this.payload = Utils.getCartResp();
        if (this.payload && (this.payload.broadbandCart ||
            this.payload.wirelessCart || this.payload.commonCart)) {
            var info = Object.create(this.payload);
            if (info.wirelessCart && info.wirelessCart.requiredToCheckout) {
                var requiredToCheckout = info.wirelessCart.requiredToCheckout;
                for (var fIndex in requiredToCheckout) {
                    if (requiredToCheckout[fIndex]) {
                        this.toCheckout[String(requiredToCheckout[fIndex])] = true;
                        this.isCartIncomplete = true;
                    }
                }
            }
            else if (info.commonCart && info.commonCart.requiredToCheckout) {
                var requiredToCheckout = info.commonCart.requiredToCheckout;
                for (var fIndex in requiredToCheckout) {
                    if (requiredToCheckout[fIndex]) {
                        this.toCheckout[String(requiredToCheckout[fIndex])] = true;
                        this.isCartIncomplete = true;
                    }
                }
            }
            else if ((_a = info.broadbandCart) === null || _a === void 0 ? void 0 : _a.requiredToCheckout) {
                var requiredToCheckout = info.broadbandCart.requiredToCheckout;
                for (var fIndex in requiredToCheckout) {
                    if (requiredToCheckout[fIndex]) {
                        this.toCheckout[String(requiredToCheckout[fIndex])] = true;
                        this.isCartIncomplete = true;
                    }
                }
            }
            else if (info && info.cartStatus &&
                !info.cartStatus.readyToCheckout && info.cartStatus.cartState &&
                info.cartStatus.cartState.toUpperCase() === 'INCOMPLETE') {
                this.toCheckout.DEFAULT_INCOMPLETE_MESSAGE = true;
                this.isCartIncomplete = true;
            }
        }
    };
    IncompleteCart.prototype.errorMsg = function () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
        this.payload = Utils.getCartResp();
        var mixMatch = this.payload
            && this.payload.wirelessCart
            && this.payload.wirelessCart.mixAndMatch;
        var isPrepaid = ((_d = (_c = (_b = (_a = this.payload) === null || _a === void 0 ? void 0 : _a.metadata) === null || _b === void 0 ? void 0 : _b.metadata) === null || _c === void 0 ? void 0 : _c.wirelessMetadata) === null || _d === void 0 ? void 0 : _d.paymentType) === CartViewPanelProps_1.PlanType.WIRELESS_PREPAID;
        var isExpressPrepaidCart = cartUtils.isExpupgradeViewEnable() && isPrepaid;
        var isCommonCart = (_e = this.payload) === null || _e === void 0 ? void 0 : _e.commonCart;
        var isNewWireless = cartUtils.isNewWirelessPostpaidView();
        var isPlansfirstflow = cartUtils.checkPostpaidPlansFirstFlow();
        var linesCount = (_j = (_h = (_g = (_f = this.payload) === null || _f === void 0 ? void 0 : _f.metadata) === null || _g === void 0 ? void 0 : _g.metadata) === null || _h === void 0 ? void 0 : _h.wirelessMetadata) === null || _j === void 0 ? void 0 : _j.planCount;
        var plansfirstMessage = linesCount ? (_l = (_k = this.cmsContent) === null || _k === void 0 ? void 0 : _k.lineAdditionLabel) === null || _l === void 0 ? void 0 : _l.replace('{0}', linesCount.toString()) : '';
        return (React.createElement("div", { id: "incompleteCartErrorMsg" },
            !mixMatch && !isExpressPrepaidCart && !isCommonCart && !isNewWireless && !isPlansfirstflow &&
                React.createElement(components_1.Alert, { closeable: true, onWhite: true, testId: utils_1.default('Cart', 'IncompleteLobError', '_msg'), type: "error" },
                    React.createElement(ui_components_1.Label, { data: { text: this.toCheckout.WLS_DEVICE_CELLPHONE ?
                                this.cmsContent.cellphoneErrTxt : this.cmsContent.apiErrTxt }, options: {
                            className: cartConfigCss.rennyErrormsg,
                            size: LabelProps_1.LabelSizes.MEDIUM,
                        } }),
                    this.toCheckout.WLS_PLAN &&
                        React.createElement("div", { className: localStyles.mediumlink },
                            React.createElement(components_1.Link, { testId: utils_1.default('Link', 'PLAN_Link'), kind: "textPlain", onClick: this.addWirelessPlan.bind(this, IncompleteCartProps_1.IncompleteCartTypes.WLS_PLAN) }, this.cmsContent.wirelessPlanIsMissingLinkLabel)),
                    this.toCheckout.WLS_DEVICE_CELLPHONE &&
                        React.createElement("div", { className: localStyles.linkpace },
                            React.createElement(components_1.Link, { kind: "textPlain", testId: utils_1.default('Link', 'CELLPHONE_Link'), onClick: this.addWirelessPlan.bind(this, IncompleteCartProps_1.IncompleteCartTypes.WLS_DEVICE_CELLPHONE) }, this.cmsContent.mixAndMatchGoBack)),
                    this.toCheckout.WLS_DEVICE &&
                        React.createElement("div", { className: localStyles.linkpace },
                            React.createElement(components_1.Link, { kind: "textPlain", testId: utils_1.default('Link', 'DEVICE_Link'), onClick: this.addWirelessPlan.bind(this, IncompleteCartProps_1.IncompleteCartTypes.WLS_DEVICE) }, this.cmsContent.wirelessDeviceIsMissingLinkLabel)),
                    this.toCheckout.DTVS_ADDON &&
                        React.createElement("div", { className: localStyles.linkpace },
                            React.createElement(components_1.Link, { kind: "textPlain", testId: utils_1.default('Link', 'ADDON_Link'), onClick: this.addWirelessPlan.bind(this, IncompleteCartProps_1.IncompleteCartTypes.DTVS_ADDON) }, this.cmsContent.configIsIncompleteLinkLabel)),
                    this.toCheckout.IPTV_ADDON &&
                        React.createElement("div", { className: localStyles.linkpace },
                            React.createElement(components_1.Link, { kind: "textPlain", testId: utils_1.default('Link', 'ADDON_Link'), onClick: this.addWirelessPlan.bind(this, IncompleteCartProps_1.IncompleteCartTypes.IPTV_ADDON) }, this.cmsContent.configIsIncompleteLinkLabel)),
                    this.toCheckout.DEFAULT_INCOMPLETE_MESSAGE &&
                        React.createElement("div", { className: localStyles.linkpace },
                            React.createElement(components_1.Link, { kind: "textPlain", testId: utils_1.default('Link', 'DEFAULT_Link'), onClick: this.addWirelessPlan.bind(this, IncompleteCartProps_1.IncompleteCartTypes.DEFAULT_INCOMPLETE) }, this.cmsContent.configIsIncompleteLinkLabel))),
            (mixMatch || isExpressPrepaidCart || isCommonCart || cartUtils.isNewWirelessPostpaidView())
                && !isPlansfirstflow &&
                React.createElement(components_1.Alert, { closeable: false, onWhite: true, testId: utils_1.default('Cart', 'IncompleteLobError', '_msg'), type: "error" },
                    React.createElement("div", { className: localStyles.greycolor },
                        React.createElement("strong", null, this.cmsContent.errMessageHeading)),
                    React.createElement(ui_components_1.Label, { data: { text: (this.toCheckout.WLS_DEVICE_CELLPHONE) ?
                                this.cmsContent.mixAndMatchNoDeviceError : this.cmsContent.mixAndMatchErrorLabel }, options: {
                            className: localStyles.greyerrormsg,
                            size: LabelProps_1.LabelSizes.MEDIUM
                        } }),
                    this.toCheckout.WLS_DEVICE_CELLPHONE &&
                        React.createElement("div", { className: localStyles.linkpace },
                            React.createElement(components_1.Link, { testId: utils_1.default('Link', 'CELLPHONE_Link'), kind: "textPlain", onClick: this.addWirelessPlan.bind(this, IncompleteCartProps_1.IncompleteCartTypes.WLS_DEVICE) }, this.cmsContent.mixAndMatchGoBack))),
            mixMatch && isPlansfirstflow && this.toCheckout.WLS_DEVICE &&
                React.createElement(components_1.Alert, { closeable: false, onWhite: true, testId: utils_1.default('Cart', 'IncompleteLobError', '_msg'), type: "success" },
                    React.createElement(ui_components_1.Label, { data: {
                            text: plansfirstMessage,
                        }, options: {
                            className: localStyles.greyerrormsg,
                            size: LabelProps_1.LabelSizes.MEDIUM,
                        } }))));
    };
    IncompleteCart.prototype.addWirelessPlan = function (val) {
        var isPSC = !!(this.payload && this.payload.wirelessCart
            && (this.payload.wirelessCart._cartCreationSource === 'PSC'));
        var isBBPSC = !!(this.payload && this.payload.broadbandCart
            && (this.payload.broadbandCart.cartCreationSource === 'PSCBB'));
        var isWirelessFlow = !!(this.payload && this.payload.wirelessCart);
        if (Utils.isLoginRequiredonCart() &&
            (val === IncompleteCartProps_1.IncompleteCartTypes.WLS_PLAN || val === IncompleteCartProps_1.IncompleteCartTypes.WLS_DEVICE ||
                val === IncompleteCartProps_1.IncompleteCartTypes.WLS_DEVICE_CELLPHONE)) {
            var loginURL = Utils.getauthenticatedPersistantLoginURL();
            var reportingLinkName = '';
            if (val === IncompleteCartProps_1.IncompleteCartTypes.WLS_PLAN) {
                reportingLinkName = this.cmsContent.wirelessPlanIsMissingLinkLabel;
            }
            if (val === IncompleteCartProps_1.IncompleteCartTypes.WLS_DEVICE) {
                reportingLinkName = this.cmsContent.wirelessDeviceIsMissingLinkLabel;
            }
            if (val === IncompleteCartProps_1.IncompleteCartTypes.WLS_DEVICE_CELLPHONE) {
                reportingLinkName = this.cmsContent.mixAndMatchGoBack;
            }
            this.reportingService.fireLinkClickEvent(reportingLinkName, loginURL);
            if (typeof window !== undefined) {
                window.location.href = loginURL;
            }
        }
        else if (val === IncompleteCartProps_1.IncompleteCartTypes.WLS_PLAN) {
            var plansURL = Utils.getCurrentFlowType() === CartHelperFunctions_1.FlowType.WIRELESS_PREPAID ? '/wireless/prepaid/plans' :
                '/wireless/plans';
            plansURL = isPSC ? '/phones/' : plansURL;
            this.reportingService.fireLinkClickEvent(this.cmsContent.wirelessPlanIsMissingLinkLabel, plansURL);
            if (isPSC) {
                window.location.href = '/buy' + plansURL;
            }
            else {
                routables_1.history.push(plansURL);
            }
        }
        else if (val === IncompleteCartProps_1.IncompleteCartTypes.WLS_DEVICE) {
            var devicesURL = Utils.getCurrentFlowType() === CartHelperFunctions_1.FlowType.WIRELESS_PREPAID ? '/wireless/prepaid/devices' :
                '/wireless/devices';
            devicesURL = isPSC ? '/phones/' : devicesURL;
            this.reportingService.fireLinkClickEvent(this.cmsContent.wirelessDeviceIsMissingLinkLabel, devicesURL);
            if (isPSC) {
                window.location.href = '/buy' + devicesURL;
            }
            else {
                routables_1.history.push(devicesURL);
            }
        }
        else if (val === IncompleteCartProps_1.IncompleteCartTypes.WLS_DEVICE_CELLPHONE) {
            var devicesURL = '/wireless/devices';
            devicesURL = isPSC ? '/phones/' : devicesURL;
            this.reportingService.fireLinkClickEvent(this.cmsContent.mixAndMatchGoBack, devicesURL);
            if (isPSC) {
                window.location.href = '/buy' + devicesURL;
            }
            else {
                routables_1.history.push(devicesURL);
            }
        }
        else if (val === IncompleteCartProps_1.IncompleteCartTypes.DEFAULT_INCOMPLETE && isWirelessFlow) {
            var wirelessUrl = '/wireless';
            wirelessUrl = isPSC ? '/phones/' : wirelessUrl;
            this.reportingService.fireLinkClickEvent(this.cmsContent.configIsIncompleteLinkLabel, wirelessUrl);
            if (isPSC) {
                window.location.href = '/buy' + wirelessUrl;
            }
            else {
                routables_1.history.push(wirelessUrl);
            }
        }
        else if (val === IncompleteCartProps_1.IncompleteCartTypes.DTVS_ADDON && isBBPSC) {
            this.reportingService.fireLinkClickWithOutPageLoad(this.cmsContent.configIsIncompleteLinkLabel, '/buy/broadband');
            window.location.href = '/buy/broadband';
        }
        else if ((val === IncompleteCartProps_1.IncompleteCartTypes.DTVS_ADDON) || (val === IncompleteCartProps_1.IncompleteCartTypes.IPTV_ADDON)) {
            this.reportingService.fireLinkClickWithOutPageLoad(this.cmsContent.configIsIncompleteLinkLabel, '/buy/bundles/#TV');
            routables_1.history.push('/bundles/#TV');
        }
        else if (val === IncompleteCartProps_1.IncompleteCartTypes.DEFAULT_INCOMPLETE) {
            var redirectionUrl = isBBPSC ? '/broadband' : '/bundles';
            this.reportingService.fireLinkClickWithOutPageLoad(this.cmsContent.configIsIncompleteLinkLabel, "/buy" + redirectionUrl);
            if (isBBPSC) {
                window.location.href = '/buy' + redirectionUrl;
            }
            else {
                routables_1.history.push(redirectionUrl);
            }
        }
    };
    return IncompleteCart;
}(React.Component));
exports.default = IncompleteCart;
//# sourceMappingURL=IncompleteCart.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/components/atoms/IncompleteCart/IncompleteCart.js
// module id = 2327
// module chunks = 8